import axios from 'axios';

export function getCountries() {
    return axios({
        method: 'get',
        url: '/api/v1/countries',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}




// WEBPACK FOOTER //
// ./app/services/counties.js